import './Feature.css';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { withTranslate } from 'react-redux-multilingual';
import { keyframes } from "@emotion/react";
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

import Video from '../../blocks/Video/Video';
import FadeInSection from '../../blocks/FadeInSection/FadeInSection';

import Logo from "../../../../src/logo.svg";

import Gmail from '../../../libraries/Icons/gmail.png';
import GoogleSpreadsheets from '../../../libraries/Icons/GoogleSpreadsheets.png';
import GoogleDrive from '../../../libraries/Icons/GoogleDrive.png';
import GoogleCalendar from '../../../libraries/Icons/GoogleCalendar.png';
import Chromium from "../../../libraries/Icons/chromium.png";
import AwsS3 from '../../../libraries/Icons/AwsS3.png';
import Filemaker from '../../../libraries/Icons/Filemaker.png';
import Excel from "../../../libraries/Icons/excel.png";
import Txt from "../../../libraries/Icons/txt.png";
import Cloudsign from "../../../libraries/Icons/cloudsign.png";

const scale = keyframes`
    0 %  { transform: scale(1); },
    100% { transform: scale(2); }
`;

function Feature(props) {
    const { translate } = props;

    const features = [
        { title: translate('chromiumtitle'), description: translate('chromiumdescription'), url: 'https://youtu.be/AnX7--l6vzQ' },
        { title: translate('exceltitle'), description: translate('exceldescription'), url: 'https://youtu.be/AnX7--l6vzQ' },
        { title: translate('gmailtitle'), description: translate('gmaildescription'), url: 'https://youtu.be/AnX7--l6vzQ' },
        { title: translate('googlespreadsheettitle'), description: translate('googlespreadsheetdescription'), url: 'https://youtu.be/AnX7--l6vzQ' },
        { title: translate('googledrivetitle'), description: translate('googledrivedescription'), url: 'https://youtu.be/AnX7--l6vzQ' },
        { title: translate('googlecalendartitle'), description: translate('googlecalendardescription'), url: 'https://youtu.be/AnX7--l6vzQ' },
        { title: translate('googledocstitle'), description: translate('googledocsdescription'), url: 'https://youtu.be/AnX7--l6vzQ' },
        { title: translate('awss3title'), description: translate('awss3description'), url: 'https://youtu.be/AnX7--l6vzQ' },
        { title: translate('filemakertitle'), description: translate('filemakerdescription'), url: 'https://youtu.be/AnX7--l6vzQ' },
        { title: translate('texttitle'), description: translate('textdescription'), url: 'https://youtu.be/AnX7--l6vzQ' },
    ]

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])

    return (
        <div className='feature'>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='section-1'>
                    <Box sx={{ p: 2 }}>
                        <FadeInSection>
                            <Typography variant="h2" gutterBottom component="h1" sx={{ fontWeight: "500", pt: 1, pb: 5 }}>
                                {translate('feature')}
                            </Typography>
                            <Typography variant="body1" gutterBottom component="p" sx={{ color: "#586978", fontSize: "1.2rem", lineHeight: "2rem", pb: 5 }}>
                                {translate('featuredescription')}
                            </Typography>
                        </FadeInSection>
                        <FadeInSection>
                            <Box sx={{ mt: 5, display: "flex", justifyContent: "center", gap: 2 }}>
                                <Button variant="contained" color="success" endIcon={<ChevronRightIcon />} component={Link} to="/register/standard">
                                {translate('tryforfree')}
                                </Button>
                                <Button variant="outlined" color="success" endIcon={<ChevronRightIcon />} component={Link} to="/contact">
                                {translate('contactsales')}
                                </Button>
                            </Box>
                        </FadeInSection>
                    </Box>
                </Box>
            </Container>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='feature-items'>
                    <FadeInSection>
                        <Box className='feature-item'>
                            <ul>
                                <Typography component="li">
                                    <img src={Logo} width={100} className='logo' />
                                </Typography>
                                {[1, 2, 3, 4, 5].map(item => <Typography component="li" sx={{ animation: `${scale} 5s infinite ease` }}></Typography>)}
                                <img src={Gmail} width={40} className='gmail-icon' />
                                <img src={GoogleSpreadsheets} width={40} className='google-spreadsheets-icon' />
                                <img src={GoogleDrive} width={40} className='google-drive-icon' />
                                <img src={GoogleCalendar} width={40} className='google-calendar-icon' />

                                <img src={Cloudsign} width={40} className='cloudsign-icon' />
                                <img src={Txt} width={40} className='txt-icon' />

                                <img src={Chromium} width={40} className='chromium-icon' />
                                <img src={AwsS3} width={40} className='aws-s3-icon' />
                                <img src={Filemaker} width={40} className='filemaker-icon' />
                                <img src={Excel} width={40} className='excel-icon' />
                            </ul>
                        </Box>
                    </FadeInSection>
                </Box>
            </Container>
            <Container maxWidth="100%" sx={{ padding: "0px !important", my: "100px" }}>
                <Box>
                    <FadeInSection>
                        <Typography variant="h2" gutterBottom component="h1" sx={{ fontWeight: "500", py: { sx: 5, md: 20 } }}>
                            {translate('incrediblyeasytogetgoing')}
                        </Typography>
                    </FadeInSection>
                </Box>
                <Divider />
                <Box sx={{ px: { xs: 2, md: 50 } }}>
                    {features.map((feature, index) => (
                    <React.Fragment>
                        <Box 
                            key={feature.title}
                            className='feature-item'
                            sx={{ display: "flex", flexDirection: { xs: 'column-reverse', md: 'row' }, gap: { xs: 2, md: 10 } }}
                        >
                            <Box className='video'>
                                <Video 
                                    width="100%"
                                    height={200} 
                                    url={feature.url}
                                    playing={true}
                                    loop={true}
                                    controls={true}
                                    muted={true}
                                    light={true}
                                />
                            </Box>
                            <Box className='description' sx={{ minWidth: { xs: "100%", md: "60%" } }}>
                                <Typography variant="h5" component="p" gutterBottom sx={{ fontWeight: 600, textAlign: "left" }}>
                                {index + 1}.&nbsp;{feature.title}
                                </Typography>
                                <Typography variant="body1" gutterBottom component="p" sx={{ color: "#586978", fontSize: "1.2rem", lineHeight: "2rem", textAlign: "left" }}>
                                {feature.description}
                                </Typography>
                            </Box>
                        </Box>
                        <Divider />
                    </React.Fragment>
                    ))}
                </Box>
            </Container>
        </div>
    );
}
export default withTranslate(Feature);